import React, { useState, useEffect, useRef } from 'react'
import Header from './Header'
import CallToAction from './CallToAction'
import UploadSection from './UploadSection'
import Photographer from './photographer-colour-1200px.png'

import { MuiThemeProvider, createTheme } from '@material-ui/core/styles'
import { blue } from '@material-ui/core/colors'
import Hidden from './hidden/Hidden'
import RedirectDialog from './RedirectDialog'
import BackButton from './back.png'
import { makeStyles } from '@material-ui/styles'
import { useMediaQuery } from '@material-ui/core'

const theme = createTheme({ palette: { primary: blue } })

const useStyles = makeStyles({
  back: {
    position: 'fixed',
    bottom: '26%',
    width: 150,
    paddingTop: '10%',
    background: `url(${BackButton})left center/contain no-repeat`,
    cursor: 'pointer'
  }
})



export default function UGC(props) {
  const { api } = props
  const classes = useStyles()

  const isMobile = useMediaQuery('(max-width: 768px)')

  const [app, setApp] = useState({})
  const [appHidden, setAppHidden] = useState(false)

  const [openRedirectDialog, setOpenRedirectDialog] = useState(false)
  const uploadSectionRef = useRef(null)

  const appId = props.match.params.appId

  useEffect(() => {
    async function getAppInfo(id) {
      const app = await api.exhibit().getShallowById(id)

      if(app.status === 'HIDDEN') {
        setAppHidden(true)
      } else {
        setDocumentTitle(app)
        if(!app.image) {
          app.image = Photographer
        }
        setApp(app)
      }
    }

    getAppInfo(appId)
  }, [appId, api])

  const setDocumentTitle = (app) => {
    document.title = app.name
  }

  const handleScrollToUploadSection = () => {
    window.scrollTo({
      top: uploadSectionRef.current.offsetTop,
      left: 0,
      behavior: 'smooth'
    })
  }

  const handleGoToRedirect = () => {
    setOpenRedirectDialog(true)
  }

  const handleGoBack = () => {
    const redirectLink = app.userGeneratedContentRedirectionLink || 'https://passitdown.com'
    window.location.href = redirectLink
  }

  return (
    <>
      {appHidden && <Hidden />}
      {!appHidden && <MuiThemeProvider theme={app.mainColor ? createTheme({
        palette: {
          primary: { main: app.mainColor },
          secondary: { main: app.secondaryColor },
        },
      }) : theme}>
        <div style={{ position: 'relative' }}>
          <Header title={app.name} />
          <div style={{ marginTop: 50 }}>
            <CallToAction app={app} api={api} scrollToUploadSection={handleScrollToUploadSection} />
          </div>
          <div ref={uploadSectionRef} style={{ marginTop: 50 }}>
            <UploadSection app={app} api={api} goToRedirect={handleGoToRedirect} />
          </div>

          <RedirectDialog
            open={openRedirectDialog}
            handleGoToRedirect={handleGoBack}
            close={() => setOpenRedirectDialog(false)} />

          <div className={classes.back} style={{ minHeight: isMobile ? 50 : 0 }} onClick={handleGoBack} />
        </div>
      </MuiThemeProvider>}
    </>
  )
}
